import { ReactNode } from "react";
import { Box } from "@mui/material";
import CustomAccordion from "@/components/CustomAccordion";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import CurrentVisitPanel from "./CurrentVisitPanel";
import { SummaryLine } from "../readmission-f2f-types";
import {
  SECTION_TITLE_COLOR,
  SECTION_TITLE_FONT_SIZE,
  UNMOUNT_ON_COLLAPSE_ACCORDION_PROPS,
} from "../readmission-f2f-constant";

export interface SectionAccordionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  summaryLines?: SummaryLine[];
  children: ReactNode;
  showCurrentVisit?: boolean;
  /** Only for sections whose state lives outside their components, since collapsing discards local state. */
  unmountWhenCollapsed?: boolean;
}

const SectionAccordion = ({
  title,
  expanded,
  onToggle,
  summaryLines = [],
  children,
  showCurrentVisit = true,
  unmountWhenCollapsed = false,
}: SectionAccordionProps) => {
  return (
    <CustomAccordion
      expanded={expanded}
      onClickHandler={onToggle}
      accordionProps={
        unmountWhenCollapsed ? UNMOUNT_ON_COLLAPSE_ACCORDION_PROPS : undefined
      }
      accordionSummaryContent={
        <Text
          fontWeight="bold"
          size={SECTION_TITLE_FONT_SIZE}
          c={SECTION_TITLE_COLOR}
        >
          {title}
        </Text>
      }
      accordionDetailsContent={
        <Flex gap={2} p={2} alignItems="flex-start" flexWrap="wrap">
          <Box
            flex={1}
            minWidth={320}
            display="flex"
            flexDirection="column"
            gap={2}
          >
            {children}
          </Box>
          {showCurrentVisit && <CurrentVisitPanel lines={summaryLines} />}
        </Flex>
      }
    />
  );
};

export default SectionAccordion;
